import { getActionTypeFromInstance } from '@ngxs/store';
import { Logout } from '../actions/auth.actions';

export function logoutPlugin(state, action, next) {
	if (getActionTypeFromInstance(action) === Logout.type) {
		const isPartnerLogin: string = localStorage.getItem('isPartnerLogin');
		state = {};
		localStorage.clear();
		sessionStorage.clear();
		if (isPartnerLogin) {
			localStorage.setItem('isPartnerLogin', isPartnerLogin);
		}
	}

	return next(state, action);
}
